import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TYPE_TOAST } from 'src/app/models/enumeraciones';

@Injectable({
	providedIn: 'root',
})
export class UtilsService {
	toast$: Observable<boolean>;
	isToastSubject: BehaviorSubject<any>;

	constructor() {
		this.isToastSubject = new BehaviorSubject<any>(undefined);
		this.toast$ = this.isToastSubject.asObservable();
	}

	ShowToast(
		mensaje: string,
		typeToast: TYPE_TOAST = TYPE_TOAST.SUCCESS,
		timeOut: number = 5000
	) {
		this.isToastSubject.next({ mensaje, typeToast, timeOut });
	}

	MuestraErrorInterno(ex?: any) {}
}
